﻿
import Vue from "vue";
import Component from "vue-class-component";
import HotEditableFormManager_ from "./hotEditable/HotEditableFormManager";
import common from "../../common";
import SharedFormManager_ from "./hotEditable/SharedFormManager";
import HotEditableFormLoader_ from "./hotEditable/HotEditableFormLoader";
import context_ from "../context";
import utilities_ from "../utilities";
import HotEditableSelectComponent_ from "./hotEditable/HotEditableSelectComponent";


declare function require(module: string): unknown;
const context = require("../context") as typeof context_;
const utilities = require("../utilities") as typeof utilities_;
// const SharedFormManager = require("./hotEditable/SharedFormManager") as SharedFormManager_;
// const HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader") as HotEditableFormLoader_;
// const HotEditableSelectComponent = require("./hotEditable/HotEditableSelectComponent") as HotEditableSelectComponent_;
// const HotEditableFormManager = require("./hotEditable/HotEditableFormManager") as HotEditableFormManager_;

@Component
class SommaireTacheAdministrativeVue extends Vue implements common.IHotEditableFormVue {
    $initialData: any;

    shared?: SharedFormManager_;
    formMode = common.HotEditableFormModes.original;
    formManager?: HotEditableFormManager_ | null;
    isVisibleToggleButton = false;
    currentItemId?: string;
    currentItemType?: string;
    currentItemTitle?: string;
    currentCommentItemId?: string;
    currentCommentId?: string;
    currentCommentText?: string;
    currentItem?: common.ITacheAdministrative | null;
    currentlyEditingItem?: boolean;
    currentlyAddingComment?: boolean;
    currentlyEditingComment?: boolean;
    /** !!ATTENTION!! Utilise SEULEMENT dans l'Addition avec les 4 categories */
    itemTypes?: common.ITacheAdministrativeType[];
    items?: common.ITacheAdministrative[];
    usageContext?: string;
    forceUpdate = "1";
    bag = {} as any;
    _bagTmp?: any;
    _manageButtonsOnFormModeChange?: boolean;
    _initialConcurrencySumCheck?: string | null;
    _defaultCreationTitle?: string;
    _onCheckItemClickCallbak?: ((item?: common.ITacheAdministrative) => void) | null;
    _onEditItemClickCallbak?: ((item?: common.ITacheAdministrative) => void) | null;
    _onDeleteItemClickCallbak?: ((item?: common.ITacheAdministrative) => void) | null;
    _onEditCommentClickCallbak?: ((comment?: common.ITacheAdministrativeCommentaire) => void) | null;
    _onEditCommentCancelClickCallbak?: ((item?: common.ITacheAdministrative, comment?: common.ITacheAdministrativeCommentaire) => void) | null;
    _onEditCommentSaveClickCallbak?: ((item?: common.ITacheAdministrative, comment?: common.ITacheAdministrativeCommentaire) => void) | null;
    _onDeleteCommentClickCallbak?: ((comment?: common.ITacheAdministrativeCommentaire) => void) | null;
    _onAddCommentClickCallbak?: ((item?: common.ITacheAdministrative) => void) | null;
    _onAddCommentCancelClickCallbak?: ((item?: common.ITacheAdministrative) => void) | null;
    _onAddCommentSaveClickCallbak?: ((item?: common.ITacheAdministrative) => void) | null;

    beforeCreate() {
        const rootId = (this as any).$initialData.vueElId as string;
        const initialConcurrencySumCheck = (this as any).$initialData.concurrencySumCheck as string || null;
        const includesConcurrencySumCheck = (this as any).$initialData.includesConcurrencySumCheck as boolean || !!initialConcurrencySumCheck;
        HotEditableFormLoader_.prepareComponentsMarkupFromTarget(true, includesConcurrencySumCheck, rootId).loadComponentsFromParent(this);

        this._initialConcurrencySumCheck = initialConcurrencySumCheck;
        this.usageContext = (this as any).$initialData.usageContext || null;
        this._bagTmp = (this as any).$initialData.bag || {};
        this.$options.el = '#' + rootId;

        this._defaultCreationTitle = "Nouvelle tâche administrative";
        this.currentItemId = '';
        this.currentItemType = '';
        this.currentItemTitle = this._defaultCreationTitle;
        this.currentCommentItemId = '';
        this.currentCommentId = '';
        this.currentCommentText = '';
        this.currentlyEditingItem = false;
        this.currentlyEditingComment = false;
        this.currentlyAddingComment = false;

        this.itemTypes = (this as any).$initialData.itemTypes || [];
        this.items = (this as any).$initialData.items || [];

        this.formManager = new HotEditableFormManager_(this, (this as any).$initialData.formName as string | null, {
            loadFormModeFromUrl: (this as any).$initialData.loadFormModeFromUrl !== false
        });
        this.shared = new SharedFormManager_(this.formManager);
    }

    destroyComponents() {
        this.formManager?.destroyComponents();
        this.formManager = null;//DESTROY (TEST)
        return this;
    }

    created() { }

    mounted() {
        this.bag = this._bagTmp;

        if (this._initialConcurrencySumCheck)
            this.$nextTick(() => {
                this.initConcurrencySumCheck(this._initialConcurrencySumCheck);
            });
    }
    setOnCheckItemClickCallbak(callback: (item?: common.ITacheAdministrative) => void) {
        this._onCheckItemClickCallbak = callback || null;
        return this;
    }
    setOnEditItemClickCallbak(callback: (item?: common.ITacheAdministrative) => void) {
        this._onEditItemClickCallbak = callback || null;
        return this;
    }
    setOnDeleteItemClickCallbak(callback: (item?: common.ITacheAdministrative) => void) {
        this._onDeleteItemClickCallbak = callback || null;
        return this;
    }
    setOnEditCommentClickCallbak(callback: (comment?: common.ITacheAdministrativeCommentaire) => void) {
        this._onEditCommentClickCallbak = callback || null;
        return this;
    }
    setOnEditCommentCancelClickCallbak(callback: (item?: common.ITacheAdministrative, comment?: common.ITacheAdministrativeCommentaire) => void) {
        this._onEditCommentCancelClickCallbak = callback || null;
        return this;
    }
    setOnEditCommentSaveClickCallbak(callback: (item?: common.ITacheAdministrative, comment?: common.ITacheAdministrativeCommentaire) => void) {
        this._onEditCommentSaveClickCallbak = callback || null;
        return this;
    }
    setOnDeleteCommentClickCallbak(callback: (comment?: common.ITacheAdministrativeCommentaire) => void) {
        this._onDeleteCommentClickCallbak = callback || null;
        return this;
    }
    setOnAddCommentClickCallbak(callback?: ((item?: common.ITacheAdministrative) => void) | null) {
        this._onAddCommentClickCallbak = callback || null;
        return this;
    }
    setOnAddCommentCancelClickCallbak(callback: (item?: common.ITacheAdministrative) => void) {
        this._onAddCommentCancelClickCallbak = callback || null;
        return this;
    }
    setOnAddCommentSaveClickCallbak(callback: (item?: common.ITacheAdministrative) => void) {
        this._onAddCommentSaveClickCallbak = callback || null;
        return this;
    }
    setItems(items: common.ITacheAdministrative[]) {
        this.items = items || [];
        return this;
    }
    setItem(item: common.ITacheAdministrative) {
        if (this.items)
            if (this.items)
                for (let i = 0; i < this.items.length; i++) {
                    const x = this.items[i];
                    if (x.id === item.id)
                        this.updateItem(item, x);
                }

        return this;
    }
    setComments(itemId: string, values: common.ITacheAdministrativeCommentaire[]) {
        const item = this.getItemById(itemId);
        if (!item)
            return this;
        item.comments = values || [];
        return this;
    }
    getBagRaw() {
        const r = utilities.serializeBag(this.bag || {});
        return r;
    }
    private updateItem(source: common.ITacheAdministrative, destination: common.ITacheAdministrative) {
        if (!source)
            throw "L'argument 'source' est NULL.";
        if (!destination)
            throw "L'argument 'destination' est NULL.";
        destination.id = source.id;
        destination.date = source.date;
        destination.dateRappel = source.dateRappel;
        destination.title = source.title;
        destination.description = source.description;
        destination.icon = source.icon;
        destination.isDone = source.isDone;
        destination.typeName = source.typeName;
        destination.author = source.author;
        destination.comments = source.comments;
        destination.commentNewText = source.commentNewText;
        destination.currentlyAddingComment = source.currentlyAddingComment;
        destination.currentlyEditingItem = source.currentlyEditingItem;
    }
    getFromBag(key: string) {
        const r = this.bag[key];
        return r || r === false || r === 0 || r === '' ? r : null;
    }
    setToBag(key: string, value: any) {
        this.$set(this.bag, key, value);
        return this;
    }
    getBooleanFromBag(key: string, defaultValue?: boolean) {
        const val = this.getFromBag(key);
        if (val === true || val === false)
            return val;
        return defaultValue ?? false;
    }
    setBooleanToBag(key: string, value: boolean) {
        this.setToBag(key, value === true);
        return this;
    }
    updateBagWhere(whereClause: (key: string, val?: any) => boolean, value?: any) {
        if (whereClause)
            for (let k in this.bag)
                if (whereClause(k, this.bag[k]))
                    this.bag[k] = value;
    }
    updateBagWhereKeyStartWith(startWith: string, value?: any, excludedKeys?: string | string[]) {
        if (!startWith) return;
        excludedKeys = excludedKeys || [];
        if (!Array.isArray(excludedKeys))
            excludedKeys = [excludedKeys];
        const isExcluded = (x: string) => {
            if (x)
                for (let i = 0; i < excludedKeys.length; i++)
                    if (excludedKeys[i] === x)
                        return true;
            return false;
        };
        this.updateBagWhere(k => !isExcluded(k) && k.startsWith(startWith), value);
    }
    updateBag(updated?: common.IBag) {
        var isUpdated = false;
        if (updated && updated.raw)
            for (let k in updated.raw) {
                this.bag[k] = (updated.raw as any)[k];
                if (!isUpdated)
                    isUpdated = true;
            }

        if (isUpdated)
            this.$forceUpdate();
        return this;
    }
    private initConcurrencySumCheck(sumCheck?: string | null) {
        const f = this.formManager?.getFieldByName("ConcurrencySumCheck");
        if (f)
            f.setFromTextualValue(sumCheck || '');
        return this;
    }
    setManageButtonsOnFormModeChange(value: boolean) {
        this._manageButtonsOnFormModeChange = value !== false;
        return this;
    }
    manageButtonsOnFormModeChange() {
        return this._manageButtonsOnFormModeChange !== false;
    }
    // setActionConfirmation(key: string, action?: () => void) {
    //     if (!key)
    //         throw "L'argument 'key' est NULL.";

    //     const f = this.formManager.getFieldByName(key);

    //     if (!f)
    //         throw "Le champ correspondant au nom '" + key + "' n'existe pas.";

    //     f.setFromTextualValue("true");

    //     if (action)
    //         this.$nextTick(action);

    //     return this;
    // }
    getIcon(item: common.ITacheAdministrative) {
        const t = this.getItemTypeByName(item.typeName);
        return t ? t.icon : item.icon || 'i-note';
    }
    getItemIconTitle(item: common.ITacheAdministrative) {
        return this.getItemTypeTitleByName(item.typeName);
    }
    getItemTitle(item: common.ITacheAdministrative) {
        if (item.currentlyEditingItem)
            return "Cette tâche administrative est en cours de modification.";
        return this.getItemTypeTitleByName(item.typeName);
    }
    getItemDescription(item: common.ITacheAdministrative) {
        return utilities.replaceLineBreakByBrTag(item.description);
    }
    getAddCommentActionTitle(item: common.ITacheAdministrative) {
        if (this.currentlyEditingItem)
            return "Une tâche administrative est déjà en cours de modification";
        if (this.currentlyEditingComment)
            return "Un commentaire est déjà en cours de modification";
        if (this.currentlyAddingComment)
            return "Un commentaire est déjà en cours de création";
        return "Ajouter un commentaire";
    }
    onCheckItemClick($event: Event, item: common.ITacheAdministrative) {
        if (this._onCheckItemClickCallbak)
            this._onCheckItemClickCallbak(item);
    }
    onEditItemClick($event: Event, item: common.ITacheAdministrative) {
        if (this.isSameItem(item, this.currentItem))
            return;
        if (this._onEditItemClickCallbak)
            this._onEditItemClickCallbak(item);
    }
    onDeleteItemClick($event: Event, item: common.ITacheAdministrative) {
        if (this._onDeleteItemClickCallbak)
            this._onDeleteItemClickCallbak(item);
    }
    onEditCommentClick($event: Event, comment: common.ITacheAdministrativeCommentaire) {
        if (this.currentlyEditingItem || this.currentlyAddingComment || this.currentlyEditingComment)
            return;

        if (this._onEditCommentClickCallbak)
            this._onEditCommentClickCallbak(comment);
    }
    onDeleteCommentClick($event: Event, comment: common.ITacheAdministrativeCommentaire) {
        if (this._onDeleteCommentClickCallbak)
            this._onDeleteCommentClickCallbak(comment);
    }
    onEditCommentCancelClick($event: Event, item: common.ITacheAdministrative, comment: common.ITacheAdministrativeCommentaire) {
        if (this._onEditCommentCancelClickCallbak)
            this._onEditCommentCancelClickCallbak(item, comment);
    }
    onEditCommentSaveClick($event: Event, item: common.ITacheAdministrative, comment: common.ITacheAdministrativeCommentaire) {
        if (this._onEditCommentSaveClickCallbak)
            this._onEditCommentSaveClickCallbak(item, comment);
    }
    onAddCommentClick($event: Event, item: common.ITacheAdministrative) {
        if (this.currentlyEditingItem || this.currentlyAddingComment || this.currentlyEditingComment)
            return;

        if (this._onAddCommentClickCallbak)
            this._onAddCommentClickCallbak(item);
    }
    onAddCommentSaveClick($event: Event, item: common.ITacheAdministrative) {
        if (this._onAddCommentSaveClickCallbak)
            this._onAddCommentSaveClickCallbak(item);
    }
    onAddCommentCancelClick($event: Event, item: common.ITacheAdministrative) {
        if (this._onAddCommentCancelClickCallbak)
            this._onAddCommentCancelClickCallbak(item);
    }
    onCancelButtonClick() {
        this.resetCurrentItem();
    }
    hasReminderDate(item: common.ITacheAdministrative) {
        return item.isDone ? false : !!this.getItemDateRappelRaw(item);
    }
    isSameItem(a?: common.ITacheAdministrative | null, b?: common.ITacheAdministrative | null) {
        return a && b && a.id === b.id;
    }
    hasDescription() {
        const field = this.formManager?.getFieldByName("Description");
        const value = ((field?.elementValue as string) || '').trim();
        return !!value;
    }
    isEditingItem() {
        if (!this.currentItem)
            return false;

        if (this.currentItemType !== this.currentItem.typeName)
            return true;

        const description = this.formManager?.getFieldByName("Description");
        if ((description?.elementValue || '').trim() !== (this.currentItem.description || '').trim())
            return true;

        const dateRappel = this.formManager?.getFieldByName("DateRappel");
        if ((dateRappel?.elementValue || '').trim() !== (this.currentItem.dateRappel || '').trim())
            return true;

        const isDone = this.formManager?.getFieldByName("IsDone");
        if (isDone?.elementValue !== this.currentItem.isDone)
            return true;

        return false;
    }
    isAddingItem() {
        if (this.currentItemId)
            return false;

        if (this.currentItemType)
            return true;

        const description = this.formManager?.getFieldByName("Description");
        if ((description?.elementValue || '').trim())
            return true;

        const dateRappel = this.formManager?.getFieldByName("DateRappel");
        if ((dateRappel?.elementValue || '').trim())
            return true;

        const isDone = this.formManager?.getFieldByName("IsDone");
        if (isDone?.elementValue)
            return true;

        return false;
    }
    /** Si 'item' est NULL, alors retournera TRUE si une tache admin quelconque est en addition de commentaire, sinon retournera TRUE si la tache admin est en addition de commentaire. */
    isAddingComment(item?: common.ITacheAdministrative | null) {
        item = item || this.getCurrentlyAddingCommentItem();
        return item && !!(item.commentNewText || '').trim();
    }
    /** Si 'item' est NULL, alors retournera TRUE si une tache admin quelconque est en addition de commentaire, sinon retournera TRUE si la tache admin est en addition de commentaire. */
    isEditingComment(comment?: common.ITacheAdministrativeCommentaire | null) {
        comment = comment || this.getCurrentlyEditingCommentItem();
        if (!comment)
            return false;
        const a = (comment.editedText || '').trim();
        const b = (comment.textRaw || '').trim();
        return a && a !== b;
    }
    loadNewComment(item?: common.ITacheAdministrative) {
        this.closeNewComment();
        this.closeComment();

        this.setCurrentlyAddingComment(item, true);
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
    }
    closeNewComment(item?: common.ITacheAdministrative | null) {
        item = item || this.getCurrentlyAddingCommentItem();
        if (item)
            item.commentNewText = '';

        this.currentCommentId = '';
        this.currentCommentText = '';
        this.currentCommentItemId = '';
        this.setCurrentlyAddingComment(item, false);
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
    }
    saveNewComment(item: common.ITacheAdministrative) {
        this.currentCommentText = item.commentNewText;
        this.currentCommentItemId = item.id;
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
        this.$nextTick(() => {
            this.formManager?.applyUpdate("SaveNewComment", common.HotEditableActionTypes.update);
        });
    }
    saveComment(item?: common.ITacheAdministrative, comment?: common.ITacheAdministrativeCommentaire) {
        this.currentCommentItemId = item?.id;
        this.currentCommentId = comment?.id;
        this.currentCommentText = comment?.editedText || '';
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
        this.$nextTick(() => {
            this.formManager?.applyUpdate("SaveComment", common.HotEditableActionTypes.update);
        });
    }
    closeComment(comment?: common.ITacheAdministrativeCommentaire | null) {
        comment = comment || this.getCurrentlyEditingCommentItem();
        if (comment)
            comment.editedText = '';

        this.currentCommentId = '';
        this.currentCommentText = '';
        this.currentCommentItemId = '';
        this.setCurrentlyEditionComment(comment, false);
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
    }
    checkItem(item?: common.ITacheAdministrative) {
        const actionValue = item?.isDone ? "UncheckItem" : "CheckItem";
        this.currentItemId = item?.id;
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
        this.$nextTick(() => {
            this.formManager?.applyUpdate(actionValue, common.HotEditableActionTypes.update);
        });
    }
    deleteItem(item?: common.ITacheAdministrative) {
        this.currentItemId = item?.id;
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
        this.$nextTick(() => {
            this.formManager?.applyUpdate("DeleteItem", common.HotEditableActionTypes.update);
        });
    }
    deleteComment(comment?: common.ITacheAdministrativeCommentaire) {
        this.currentCommentId = comment?.id;
        this.currentCommentItemId = comment?.tacheAdministrativeId;
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
        this.$nextTick(() => {
            this.formManager?.applyUpdate("DeleteComment", common.HotEditableActionTypes.update);
        });
    }
    resetCurrentItem() {
        const prevItem = this.getCurrentEditingItem();

        this.currentItemType = '';
        this.currentItemId = '';
        this.currentItemTitle = this._defaultCreationTitle;
        this.currentItem = null;

        this.formManager?.getFieldByName("Description")?.setFromTextualValue();
        this.formManager?.getFieldByName("DateRappel")?.setFromTextualValue();
        this.formManager?.getFieldByName("IsDone")?.setFromTextualValue();

        const clear = this.formManager?.getButtonByName("Clear");
        const add = this.formManager?.getButtonByName("Add");
        const cancel = this.formManager?.getButtonByName("Cancel");
        const save = this.formManager?.getButtonByName("Save");

        clear?.show();
        add?.show();
        cancel?.hide();
        save?.hide();

        this.forEarchItemTypes(x => {
            const b = this.formManager?.getButtonByName("ApplyItemType_" + x.name);
            if (b)
                b.highlighted = false
        });
        this.selectItemByType();
        this.setCurrentlyEditionItem(prevItem, false);
        this.closeMessages();

        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
    }
    loadComment(comment?: common.ITacheAdministrativeCommentaire) {
        const prevComment = this.getCurrentlyEditingCommentItem();
        if (prevComment)
            this.closeComment(prevComment);

        this.setCurrentlyEditionComment(comment, true);

        if (comment)
            comment.editedText = comment?.textRaw.trim();

        this.currentCommentId = comment?.id;
        this.currentCommentItemId = comment?.tacheAdministrativeId;

        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
    }
    /** Pour ajouter un nouvel item, laisse l'argument 'item' NULL.  */
    loadItem(item?: common.ITacheAdministrative) {
        const prevItem = this.getCurrentEditingItem();

        this.currentItemId = item?.id;
        this.currentItemType = item?.typeName;
        this.currentItemTitle = item?.title;
        this.currentItem = item;

        const description = this.formManager?.getFieldByName("Description");
        const dateRappel = this.formManager?.getFieldByName("DateRappel");
        const isDone = this.formManager?.getFieldByName("IsDone");
        const clear = this.formManager?.getButtonByName("Clear");
        const add = this.formManager?.getButtonByName("Add");
        const cancel = this.formManager?.getButtonByName("Cancel");
        const save = this.formManager?.getButtonByName("Save");

        dateRappel?.setFromTextualValue(this.getItemDateRappelRaw(item));
        isDone?.setFromTextualValue(this.getItemIsDone(item).toString());
        description?.setFromTextualValue(utilities.replaceBrTagByLineBreak(item?.description));

        clear?.hide();
        add?.hide();
        cancel?.show();
        save?.show();

        this.closeMessages();

        // ...pour le select de categories
        this.selectItemByType(item?.typeName);

        // ...pour les 4 categories
        this.highlightItemByType(item?.typeName);

        // toggle
        this.setCurrentlyEditionItem(prevItem, false);
        this.setCurrentlyEditionItem(item, true);

        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
    }
    selectItemByType(typeName?: string) {
        const select = this.formManager?.getFieldByName("TacheAdministrativeType") as HotEditableSelectComponent_;
        if (!select)
            return null;
        select.setFromTextualValue(typeName || null);
        return select;
    }
    private getItemIsDone(item?: common.ITacheAdministrative) {
        return !!item?.isDone;
    }
    private getItemDateRappelRaw(item?: common.ITacheAdministrative) {
        const x = (item?.dateRappelRaw || '').trim();
        return x === this.getItemDateRaw(item) ? '' : x;
    }
    private getItemDateRaw(item?: common.ITacheAdministrative) {
        return (item?.dateRaw || '').trim();
    }
    getItemTypeTitle(item?: common.ITacheAdministrative) {
        const t = this.getItemTypeByName(item?.typeName);
        return t ? t.title : '';
    }
    setCurrentItemType(value: string | null) {
        this.currentItemType = value || '';
        this.highlightItemByType(value);
        this.$forceUpdate();//@@fetetrault: trouver la raison pour laquelle la prop nest pas MAJ sans le $forceUpdate().
    }
    private setCurrentlyEditionItem(item?: common.ITacheAdministrative | null, value?: boolean) {
        value = value !== false;

        this.currentlyEditingItem = value;

        if (item)
            item.currentlyEditingItem = value;
    }
    private setCurrentlyEditionComment(comment?: common.ITacheAdministrativeCommentaire | null, value?: boolean) {
        value = value !== false;

        this.currentlyEditingComment = value;

        if (comment)
            comment.currentlyEditingComment = value;
    }
    private setCurrentlyAddingComment(item?: common.ITacheAdministrative | null, value?: boolean) {
        value = value !== false;

        this.currentlyAddingComment = value;

        if (item)
            item.currentlyAddingComment = value;
    }
    private getCurrentEditingItem() {
        if (this.items)
            for (let i = 0; i < this.items.length; i++) {
                const x = this.items[i];
                if (x.currentlyEditingItem)
                    return x;
            }

        return null;
    }
    private getCurrentlyAddingCommentItem() {
        if (this.items)
            for (let i = 0; i < this.items.length; i++) {
                const x = this.items[i];
                if (x.currentlyAddingComment)
                    return x;
            }

        return null;
    }
    private getCurrentlyEditingCommentItem() {
        if (this.items)
            for (let i = 0; i < this.items.length; i++) {
                const x = this.items[i];
                if (x.comments)
                    for (let j = 0; j < x.comments.length; j++) {
                        const y = x.comments[j];
                        if (y.currentlyEditingComment)
                            return y;
                    }
            }

        return null;
    }
    private getItemById(id: string) {
        if (this.items)
            for (let i = 0; i < this.items.length; i++) {
                const x = this.items[i];
                if (x.id === id)
                    return x;
            }

        return null;
    }
    private closeMessages() {
        this.formManager?.autoCloseMessages();
        context.components.getMessagesManager().closeBySource(this.formManager?.getFormName());
    }
    private getItemTypeByName(name?: string) {
        if (name)
            if (this.itemTypes)
                for (let i = 0; i < this.itemTypes.length; i++) {
                    const t = this.itemTypes[i];
                    if (t.name === name)
                        return t;
                }

        return null;
    }
    private getItemTypeTitleByName(name: string) {
        const t = this.getItemTypeByName(name);
        return t ? t.title : '';
    }

    /** !!ATTENTION!! Utilise SEULEMENT dans l'Addition avec les 4 categories */
    private highlightItemByType(value?: string | null) {
        this.forEarchItemTypes(x => {
            const b = this.formManager?.getButtonByName("ApplyItemType_" + x.name);
            if (b)
                b.highlighted = b.actionValue === value;
        });
    }

    private forEarchItemTypes(action: (x: common.ITacheAdministrativeType) => void) {
        if (this.itemTypes)
            for (let i = 0; i < this.itemTypes.length; i++)
                action(this.itemTypes[i]);
    }
    refreshBrotherEmbeddedComponents() {
        if (!this.shared?.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared?.getCurrentEmbeddedComponentName();
        this.formManager?.refreshBrotherEmbeddedComponents(name);
        return this;
    }
    restoreBrotherEmbeddedComponents() {
        if (!this.shared?.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager?.restoreBrotherEmbeddedComponents(name);
        return this;
    }
    ensureBrotherEmbeddedComponentsIsDefaultUrl() {
        if (!this.shared?.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared?.getCurrentEmbeddedComponentName();
        this.formManager?.ensureBrotherEmbeddedComponentsIsDefaultUrl(name);
        return this;
    }
    refreshForceUpdate() {
        this.forceUpdate = utilities.createGuid("N");
    }
}

export = SommaireTacheAdministrativeVue;